export default [
    {
        path: '/',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: {
            pageTitle: 'Dashboard',
            breadcrumb: [
                {
                text: 'Dashboard',
                active: true,
                },
            ],
        },
    },
]